import React from 'react';
import { about } from '../../data/profile';
import { SectionHeading } from '../SectionHeading';
export function About() {
  return <section id="about" className="w-full bg-white py-20 lg:py-28" data-id="element-92" data-mp="oqm5prv3q9ik">
      <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-93" data-mp="12r6paq8uc9d4">
        <SectionHeading title="About" data-id="element-94" data-mp="12okk2x9fa5y2" />

        <div className="mt-14 grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-95" data-mp="yp20c4tc80wt">
          <div className="lg:col-span-7" data-id="element-96" data-mp="azhbj5ai69fm">
            <p className="font-display text-2xl leading-snug text-navy-900 sm:text-[2rem]" data-id="element-97" data-mp="b08y5qm4gwtr">
              {about.philosophy}
            </p>
            <p className="mt-8 max-w-2xl text-base leading-relaxed text-muted" data-id="element-98" data-mp="js16nvrl5vvp">
              {about.identity}
            </p>
          </div>

          <div className="lg:col-span-5 lg:border-l lg:border-line lg:pl-12" data-id="element-99" data-mp="f09lk0r78icy">
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-gold-600" data-id="element-100" data-mp="3ngmfbj08ju1p">
              Key attributes
            </p>
            <ul className="mt-6 divide-y divide-line" data-id="element-101" data-mp="3jf11nvfvnbqg">
              {about.attributes.map(attribute => <li key={attribute} className="py-4 text-[15px] font-medium text-ink first:pt-0 last:pb-0" data-id="element-102" data-mp="338ypujyl5rwr">
                  {attribute}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}